export default __webpack_public_path__ + "images/assets/396ab369121a3e9ede0f3e6b253cf329.svg";